import { render } from "./AllPracticesList.vue?vue&type=template&id=6343c7f8&scoped=true"
import script from "./AllPracticesList.vue?vue&type=script&lang=js"
export * from "./AllPracticesList.vue?vue&type=script&lang=js"

import "./AllPracticesList.vue?vue&type=style&index=0&id=6343c7f8&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6343c7f8"]])

export default __exports__